import U from './utils';
import config from './config';
import Cls from '../classes/barrel';
import pages from '../pages/barrel';
import Ex from '../extensions/barrel';
import comp from '../components/barrel';
import {confirmLeaveLeadForm} from './leadForm';

export default {
  async PREP(rec, oldVars, loaderMsg) {
    comp.loader(1, loaderMsg || '');

    const vars = typeof oldVars === 'string' ? await U.urlToObj(oldVars) : oldVars || {};

    const hdrs = await this.getAuthHdrs();
    let recipe = rec;

    if (Array.isArray(rec)) {
      const methods = rec;
      return this.exRequest({methods, hdrs});
    } else {
      if (typeof rec == 'string') {
        recipe = await this.getRecipe();
        const pageName = String(rec).trim();
        recipe.page = pageName === 'my_will' ? 'my_wills' : pageName;
      }
      if (pages.hasOwnProperty(recipe.page)) {
        if (!confirmLeaveLeadForm()) {
          comp.loader(0);
          return;
        }
        window.onbeforeunload = null;
        try {
          await this.createPage({recipe, hdrs, vars});
        } catch (err) {
          comp.loader(0);
          comp.toast((err && err.message) || 'Unable to open page');
          return;
        }
      } else {
        comp.loader(0);
        comp.toast(`Page not found: ${recipe.page}`);
        return '404 - Page not found;';
      }
    }

    comp.loader(0);
  },

  async createPage({recipe, hdrs, vars}) {
    const newClass = new Cls.BasePage({recipe, vars, hdrs});
    newClass.pageTitle = recipe.page;
    const methods = Ex[recipe.page];
    const newPage = {...newClass, ...methods};

    await newPage.prepare();
    newPage.tabs = newPage.tabsYN ? await this.getTabs(recipe.page) : [];
    pgList[recipe.page] = newPage;
    if (recipe.pageType === 'main') {
      history.pushState(JSON.stringify(newPage), '', `${recipe.page}`);
    }

    await this.renderPage(newPage, recipe);

    if (recipe.pageType === 'tab') {
      const parseState = await JSON.parse(history.state);
      if (!parseState.tabs[recipe.page].subMenu) {
        return;
      }
      // if (parseState.tabs[recipe.page].subMenu.length) {
      //   this.changeSubTab(parseState.tabs[recipe.page].subMenu[0].html_text);
      //   return;
      // } @STeph
    }
  },

  async renderPage(newPage, recipe) {
    await this.hydrateUserSession();
    U.id('shadowDiv').innerHTML = pages[recipe.page];

    switch (recipe.pageType) {
      case 'main':
        window.thsPage = newPage;
        break;
      case 'tab':
        window.thsTab = newPage;
        break;
      case 'subTab':
        window.thsSubTab = newPage;
        break;
      default:
        break;
    }

    await newPage.render();
    // Move real DOM nodes — do not re-assign innerHTML, or all addEventListener
    // handlers attached during render() are lost (tabs + any page that wires UI in render).
    const shadow = U.id('shadowDiv');
    const target = U.id(`${recipe.div}`);
    target.innerHTML = '';
    while (shadow.firstChild) {
      target.appendChild(shadow.firstChild);
    }

    const heroPages = ['Login', 'HomePage'];
    if (heroPages.includes(recipe.page)) {
      document.body.classList.add('page-hero');
      if (recipe.page === 'HomePage') {
        const navInput = document.getElementById('navRibbonInput');
        if (navInput) {
          navInput.placeholder = 'Search Will number (only)';
        }
      }
    } else {
      document.body.classList.remove('page-hero');
      const navInput = document.getElementById('navRibbonInput');
      if (navInput) {
        navInput.placeholder = 'Will number (only)';
      }
    }
  },

  // Fetch calls
  async exRequest({methods, hdrs}) {
    try {
      const data = methods.length ? await this.fetchMethods({methods, hdrs}) : {};
      comp.loader(0);
      return data;
    } catch (err) {
      comp.loader(0);
      //@STEPH error handling here
      this.handleFetchError(err);
      throw err;
    }
  },

  async fetchMethods({methods, hdrs}) {
    if (!methods.length) {
      return 'Method Array Empty';
    }

    const data = await Promise.all(
      methods.map(async (method) => {
        try {
          const res = await this.dataSwitch({method, hdrs});

          const statusCodeKey = `${method.method}_SC`;
          const statusTextKey = `${method.method}_ST`;

          return {
            [statusCodeKey]: res.statusCode,
            [statusTextKey]: res.statusText,
            [method.method]: res.data,
          };
        } catch (error) {
          throw error;
        }
      })
    );

    return Object.assign({}, ...data);
  },

  async dataSwitch({method, hdrs}) {
    try {
      switch (method.reqType) {
        case 'POST':
          return await this.postMethod({method, hdrs});
        case 'GET':
          return await this.getMethod({method, hdrs});
        default:
          throw new Error('Unsupported request type');
      }
    } catch (error) {
      if (error.status === 401) {
        const refresh = await this.refreshTokens();
        if (refresh) {
          // Retry the original request after refreshing tokens
          return await this.dataSwitch({method, hdrs});
        } else {
          throw 'Please log in again';
        }
      } else {
        throw error;
      }
    }
  },

  async postMethod({method, hdrs}) {
    let body = method.vars || {};

    body.user_uuid = hdrs.user_uuid ? hdrs.user_uuid : '';
    try {
      const response = await fetch(method.endPoint + method.method, {
        method: method.reqType,
        headers: {
          Authorization: `Bearer ${hdrs.token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      const parsedData = await this.handleResponse(response);

      return {
        data: parsedData,
        statusCode: response.status,
        statusText: response.statusText,
      };
    } catch (error) {
      throw error;
    }
  },

  async getMethod({method, hdrs}) {
    const tempVars = method.vars ? method.vars : {};

    if (typeof tempVars !== 'object') {
      throw new Error('System Error');
    }

    const vars = Object.entries(tempVars)
      .map(([key, value]) => `${key}=${value}`)
      .join('/');

    const url = `${method.endPoint}${method.method}?${vars}`;
    try {
      const response = await fetch(url, {
        method: method.reqType,
        headers: {
          Authorization: `Bearer ${hdrs.token}`,
          'Content-Type': 'application/json',
        },
      });

      const parsedData = await this.handleResponse(response);

      return {
        data: parsedData,
        statusCode: response.status,
        statusText: response.statusText,
      };
    } catch (error) {
      throw error;
    }
  },

  async handleResponse(response) {
    if (response.ok) {
      const res = await response.json();
      this.handleFetchFeedback({status: response.status, message: res.status});
      return res;
    } else {
      const errorData = await response.json();
      throw {status: response.status, data: errorData};
    }
  },

  async handleFetchError(error) {
    let errorMsg = 'An error occurred. Please try again.';
    let errorTitle = 'Error';

    // Handle regular Error objects
    if (error instanceof Error) {
      errorMsg = error.message || errorMsg;
      comp.errorBox(errorTitle, errorMsg);
      comp.loader(0);
      return;
    }

    // Handle structured errors with status codes
    if (error && typeof error.status === 'number' && error.data) {
      // Check error.data.error first (most common API error format)
      if (error.data.error && typeof error.data.error === 'string') {
        errorMsg = error.data.error;
      }
      // Check error.data.data.error (nested structure)
      else if (error.data.data && error.data.data.error && typeof error.data.data.error === 'string') {
        errorMsg = error.data.data.error;
      }
      // Check error.data.message
      else if (error.data.message && typeof error.data.message === 'string') {
        errorMsg = error.data.message;
      }
      // Check error.error (top level)
      else if (error.error && typeof error.error === 'string') {
        errorMsg = error.error;
      }
      // Check error.message
      else if (error.message && typeof error.message === 'string') {
        errorMsg = error.message;
      }

      // Get error title
      if (error.data.status && typeof error.data.status === 'string') {
        errorTitle = error.data.status;
      }

      switch (true) {
        case error.status >= 400 && error.status < 500:
          comp.errorBox(errorTitle, errorMsg);
          break;
        case error.status >= 500 && error.status < 600:
          comp.errorBox('Error', 'There was an error with the server. Please contact your system administrator.');
          break;
        default:
          comp.errorBox('Error', errorMsg);
      }
      comp.loader(0);
      return;
    }

    // Fallback
    if (error?.message) {
      errorMsg = typeof error.message === 'string' ? error.message : String(error.message);
    } else if (error?.error) {
      errorMsg = typeof error.error === 'string' ? error.error : String(error.error);
    }
    
    comp.errorBox('Error', errorMsg);
    comp.loader(0);
  },

  async handleFetchFeedback({status, message}) {
    switch (true) {
      case status === 209:
        comp.toast(message);
        break;
    }
  },

  async getAuthHdrs() {
    const user_uuid = await O.getCookie('ewttgpvwwkf');
    const token = await O.getCookie('vvjsdugfie');
    const language_id = await O.getCookie('mbohvbhfje');

    const vars = {};
    vars.token = token.value;

    if (!token.value) {
      await this.refreshTokens();
      const token2 = await O.getCookie('vvjsdugfie');
      vars.token = token2.value;
    }

    vars.user_uuid = user_uuid.value;
    vars.language_id = language_id.value;

    return vars;
  },

  async popstate(page) {
    if (!confirmLeaveLeadForm()) {
      if (window.thsPage && window.thsPage.pageTitle) {
        history.pushState(JSON.stringify(window.thsPage), '', window.thsPage.pageTitle);
      }
      return;
    }
    window.onbeforeunload = null;
    const parsePage = JSON.parse(page);

    if (parsePage.pageTitle === 'Login') {
      return location.reload();
    }

    if (U.id('mainNavigation')) {
      if (!U.id('mainNavigation').hasChildNodes()) {
        await comp.navigation();
      }
    }

    const methods = Ex[parsePage.pageTitle];
    const newPage = {...parsePage, ...methods};

    pgList[parsePage.pageTitle] = pgList[parsePage.pageTitle] ? pgList[parsePage.pageTitle] : newPage;

    await this.renderPage(pgList[parsePage.pageTitle], parsePage.recipe);
  },

  async getRecipe() {
    return new Cls.Recipe();
  },

  async logRes(res) {
    let dataObj = {};
    let statusCodes = {};
    let statusTexts = {};

    for (let item in res.data) {
      let split = item.split('_');
      if (split.length > 1) {
        if (split[1] === 'SC') {
          statusCodes[item] = res.data[item];
        } else {
          statusTexts[item] = res.data[item];
        }
      } else {
        dataObj[item] = res.data[item];
      }
    }
    res.data = dataObj;
    res.statusCodes = statusCodes;
    res.statusTexts = statusTexts;
  },

  async fetchFile(recipe, headers, method) {
    return new Promise((resolve, reject) => {
      let res;
      fetch(`${recipe.endPoint}${method.method}`, {
        method: recipe.type,
        body: headers,
      })
        .then((response) => {
          if (response.status === 500) {
            reject(`Failed to fetch method=${method}`);
          } else if (response.status === 401) {
            reject(response.statusText);
          } else if (response.status === 402) {
            reject(response.statusText);
          } else if (response.status === 409) {
            reject(response.statusText);
          } else if (response.status === 400) {
            reject(response.statusText);
          } else {
            res = response;
            return response.arrayBuffer();
          }
        })
        .then((parseData) => {
          downloadFile(parseData, method.fileName);
          resolve({
            data: true,
            statusCode: res.status,
            statusText: res.statusText,
          });
        })
        .catch(() => {});
    });
  },

  async initSession({user_uuid, token, refreshToken, language_id, default_open_applications_yn, autofill_id_yn, white_label, allow_invite_client_fulfillment} = {}) {
    const devID = await U.uuidvMain();
    const tokenExpirationTime = new Date();
    tokenExpirationTime.setTime(tokenExpirationTime.getTime() + 45 * 60 * 1000); // 45 minutes in milliseconds

    user_uuid && (await this.createCookie('ewttgpvwwkf', user_uuid));
    refreshToken &&
      (await this.createCookie('fdenfoindk', refreshToken, {
        // expires: tokenExpirationTime,
        // secure: true,
        // httpOnly: true,
      }));
    token &&
      (await this.createCookie('vvjsdugfie', token, {
        expires: tokenExpirationTime,
        // secure: true,
        // httpOnly: true,
      }));
    language_id && (await this.createCookie('mbohvbhfje', language_id));
    default_open_applications_yn != null && (await this.createCookie('xyndfltopn', default_open_applications_yn));
    autofill_id_yn != null && (await this.createCookie('hflidautyn', autofill_id_yn));
    allow_invite_client_fulfillment != null && (await this.createCookie('alwincffl', allow_invite_client_fulfillment));
    if (arguments[0] && Object.prototype.hasOwnProperty.call(arguments[0], 'white_label')) {
      if (white_label) {
        await this.createCookie('wlblbrandx', encodeURIComponent(String(white_label)));
      } else {
        this.deleteCookie('wlblbrandx');
      }
    }
    await this.createCookie('fgxkegwwkf', devID);
    await this.hydrateUserSession();
  },

  parseAutofillTruthy(val) {
    if (val == null || val === '') return false;
    if (val === true) return true;
    const normalized = String(val).trim().toLowerCase();
    return normalized === 'true' || normalized === 'y' || normalized === '1' || normalized === 'yes';
  },

  getCookieValueSync(cKey) {
    const name = `${cKey}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');

    for (let cookie of ca) {
      const c = cookie.trim();
      if (c.indexOf(name) === 0) {
        return c.substring(name.length);
      }
    }
    return null;
  },

  /** Read session prefs from cookies into window.userSession for sync access across pages. */
  async hydrateUserSession() {
    window.userSession = window.userSession || {};
    const autofill = await this.getCookie('hflidautyn');
    const val = autofill?.expired ? null : autofill?.value;
    window.userSession.autofill_id_yn = this.parseAutofillTruthy(val);
    const inviteFulfillment = await this.getCookie('alwincffl');
    const inviteVal = inviteFulfillment?.expired ? null : inviteFulfillment?.value;
    window.userSession.allow_invite_client_fulfillment = this.parseAutofillTruthy(inviteVal);
    const whiteLabel = await this.getCookie('wlblbrandx');
    const rawLabel = whiteLabel?.expired ? '' : whiteLabel?.value || '';
    let decodedLabel = rawLabel;
    try {
      decodedLabel = rawLabel ? decodeURIComponent(rawLabel) : '';
    } catch (err) {
      decodedLabel = rawLabel;
    }
    window.userSession.white_label = decodedLabel || null;
  },

  canAutofillId() {
    if (window.userSession && window.userSession.autofill_id_yn) {
      return true;
    }
    return this.parseAutofillTruthy(this.getCookieValueSync('hflidautyn'));
  },

  canInviteClientFulfillment() {
    if (window.userSession && window.userSession.allow_invite_client_fulfillment) {
      return true;
    }
    return this.parseAutofillTruthy(this.getCookieValueSync('alwincffl'));
  },

  async getCookie(cKey) {
    let name = cKey + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');

    for (let cookie of ca) {
      let c = cookie.trim();

      if (c.indexOf(name) == 0) {
        let cookieValue = c.substring(name.length);
        let expiresIndex = cookie.indexOf('expires=');

        if (expiresIndex !== -1) {
          let expiresString = c.substring(expiresIndex + 'expires='.length).trim();
          let expiresDate = new Date(expiresString);

          if (expiresDate.getTime() < Date.now()) {
            return {value: cookieValue, expired: true};
          }
        }
        return {value: cookieValue, expired: false};
      }
    }

    return {value: null, expired: false};
  },

  async createCookie(cKey, cValue, options = {}) {
    return new Promise((resolve) => {
      const defaultOptions = {secure: false, httpOnly: false, expires: null, sameSite: 'Lax'};

      const mergedOptions = {...defaultOptions, ...options};

      let cookieString = `${cKey}=${cValue}`;

      if (mergedOptions.expires) {
        const expires = new Date(mergedOptions.expires);
        cookieString += `;expires=${expires.toUTCString()}`;
      }

      if (mergedOptions.secure) {
        cookieString += ';secure';
      }

      if (mergedOptions.httpOnly) {
        cookieString += ';httpOnly';
      }

      if (mergedOptions.sameSite) {
        cookieString += `;sameSite=${mergedOptions.sameSite}`;
      }

      document.cookie = cookieString;

      resolve({success: true, message: 'Cookie created successfully'});
    });
  },

  async mGET(method, vars) {
    const newReq = new Cls.Plate(method, vars, 'GET');
    return newReq;
  },

  async mPOST(method, vars) {
    const newReq = new Cls.Plate(method, vars, 'POST');
    return newReq;
  },

  logout() {
    this.clearSession();
    history.replaceState(null, null, window.location.pathname);
    location.reload();
  },

  clearSession() {
    const sessionCookies = [
      'ewttgpvwwkf',
      'fdenfoindk',
      'vvjsdugfie',
      'mbohvbhfje',
      'xyndfltopn',
      'hflidautyn',
      'alwincffl',
      'wlblbrandx',
      'fgxkegwwkf',
      'tokdcbsll',
    ];
    sessionCookies.forEach((key) => this.deleteCookie(key));
    window.userSession = {};
  },

  deleteCookie(cKey) {
    document.cookie = `${cKey}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  },

  async changeTab(newTab, vars) {
    if (thsSubTab && thsSubTab.length) {
      thsSubTab.savePage();
    }
    const tabList = document.querySelectorAll('.tablinks');
    const recipe = await this.getRecipe();
    recipe.page = newTab;
    recipe.div = 'tabContentContainer';
    recipe.pageType = 'tab';

    tabList.forEach((tab) => {
      tab.classList.contains('active') && tab.classList.remove('active');

      if (tab.id == newTab) {
        tab.classList.add('active');
      }
    });
    this.PREP(recipe, vars || {});
    recipe.page !== 'ADs_PersonalDetails' && U.id('subTabs') && U.hide('subTabs'); //@steph
  },

  async changeSubTab(newTab, vars) {
    const tabList = document.querySelectorAll('.subTablinks');
    const recipe = await this.getRecipe();
    recipe.page = newTab;
    recipe.div = 'tabContentContainer';
    recipe.pageType = 'subTab';

    tabList.forEach((tab) => {
      tab.classList.contains('active') && tab.classList.remove('active');

      if (tab.id == newTab) {
        tab.classList.add('active');
      }
    });
    this.PREP(recipe, vars || {});
  },

  async getTabs(htmlName) {
    const vars = {};
    vars.html_text = htmlName;
    const methods = [await O.mGET('navigation/get-tabs', vars)];
    const tabs = await O.PREP(methods);
    return tabs['navigation/get-tabs'].data;
  },

  async refreshTokens() {
    let res = false;

    try {
      const {value} = await this.getCookie('fdenfoindk');

      if (value) {
        const refresh_token = value;

        const response = await fetch(`${config.apiURL}login/refresh-token`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({refresh_token}),
        });

        if (response.ok) {
          const data = await response.json();
          const {token} = data.data;
          this.initSession({token: token});
          res = true;
        }
      }
    } catch (err) {
      res = false;
    }

    return res;
  },

  getDirectApplicationUuid() {
    return new URLSearchParams(window.location.search).get('direct_application_uuid');
  },

  async isLoggedIn() {
    const user_uuid = await this.getCookie('ewttgpvwwkf');
    if (!user_uuid.value) {
      return false;
    }

    const token = await this.getCookie('vvjsdugfie');
    if (token.value && !token.expired) {
      return true;
    }

    const refresh = await this.getCookie('fdenfoindk');
    if (!refresh.value) {
      return false;
    }

    if (!token.value || token.expired) {
      return this.refreshTokens();
    }

    return true;
  },

  async bootstrapAuthenticatedApp() {
    document.body.innerHTML = pages.Master;
    await this.hydrateUserSession();
    await comp.navigation();
  },

  async navigateToDirectApplication(uuid) {
    return this.PREP('ViewApplication', `application_uuid=${uuid}`);
  },

  clearDirectApplicationParam() {
    const url = new URL(window.location.href);
    url.searchParams.delete('direct_application_uuid');
    const search = url.searchParams.toString();
    const newUrl = url.pathname + (search ? `?${search}` : '') + url.hash;
    history.replaceState(history.state, '', newUrl);
  },
};
